import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OmitService {
  /**
   * Creates a new object with the specified properties removed
   * @param object The object to omit properties from
   * @param paths The property paths to omit from the object
   * @returns A new object with the specified properties removed
   */
  static omit<T extends object>(object: T, paths: string | string[]): any {
    if (!object) {
      return object;
    }

    // Create a shallow copy of the object
    const result = { ...object };

    // Convert single path to array for consistent handling
    const pathsToOmit = Array.isArray(paths) ? paths : [paths];

    // Remove each specified path
    pathsToOmit.forEach((path) => {
      delete result[path as keyof typeof result];
    });

    return result;
  }
}
